import type { GenericObject } from "@/common/interfaces/IGeneric"
import { submodels, useCases, digitalTwinTypes } from "./dummy"
import i18n from "@/i18n"
import { ASSET_PROVISION_FORM_DATA } from "@/common/constants/provideData"
export interface IntStateData<T = any> {
  data: T[]
  isLoading: boolean
  selectedData: T[] | null
  isDisabled?: boolean
}

export interface IntProviderState {
  offerCategories: IntStateData
  aspects: IntStateData
  models: IntStateData
  useCases: IntStateData
  assetProvisionForm: GenericObject
  digitalTwinTypes: IntStateData
  aspectsCountData: number
  connectorCountData: number
}

export const getDefaultState = (): IntProviderState => {
  return {
    offerCategories: {
      data: [
        {
          id: "prepare",
          title: i18n.global.t("wizardSelectionPopup.prepare"),
          icon: '<scale-icon-service-settings accessibility-title="settings"/>'
        },
        {
          id: "provide",
          title: i18n.global.t("wizardSelectionPopup.provide"),
          icon: '<scale-icon-action-share accessibility-title="share"/>'
        },
        {
          id: "consume",
          title: i18n.global.t("wizardSelectionPopup.consume"),
          icon: '<scale-icon-content-shop accessibility-title="shop"/>'
        },
        {
          id: "govern",
          title: i18n.global.t("wizardSelectionPopup.govern"),
          icon: '<scale-icon-service-devices-service accessibility-title="devices-service"/>',
          isDisabled: true
        }
      ],
      isLoading: false,
      selectedData: null
    },
    aspects: {
      data: [],
      isLoading: false,
      selectedData: []
    },
    models: {
      data: [],
      isLoading: false,
      selectedData: []
    },
    useCases: {
      data: [],
      isLoading: false,
      selectedData: []
    },
    digitalTwinTypes: {
      data: [],
      isLoading: false,
      selectedData: []
    },
    assetProvisionForm: ASSET_PROVISION_FORM_DATA,
    aspectsCountData: 0,
    connectorCountData: 0
  }
}
